import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "label", "usePortal", "id"];
import '../../css-tokens';
import React from 'react';
import { usePopperTooltip } from 'react-popper-tooltip';
import { Info } from '@mediahuis/chameleon-theme-wl/icons';
import cx from 'classnames';
import Text from '../Text';
import Icon from '../Icon';
import Portal from '../Portal';
import styles from './index.module.css';
var SYSTEM_PROPS = [];

const Tooltip = /*#__PURE__*/function () {
  const Tooltip = function Tooltip(_ref) {
    var children = _ref.children,
        label = _ref.label,
        usePortal = _ref.usePortal,
        id = _ref.id,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);

    var only = React.Children.count(children) ? React.Children.only(children) : null;
    var Wrapper = usePortal ? Portal : React.Fragment;

    var _usePopperTooltip = usePopperTooltip(_extends({
      trigger: ['hover', 'focus']
    }, rest)),
        getArrowProps = _usePopperTooltip.getArrowProps,
        getTooltipProps = _usePopperTooltip.getTooltipProps,
        setTooltipRef = _usePopperTooltip.setTooltipRef,
        setTriggerRef = _usePopperTooltip.setTriggerRef,
        visible = _usePopperTooltip.visible;

    return /*#__PURE__*/React.createElement(React.Fragment, null, visible && /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("div", _extends({
      ref: setTooltipRef
    }, getTooltipProps({
      className: cx(styles.root, usePortal && styles.usePortal)
    })), /*#__PURE__*/React.createElement(Text, {
      id: id,
      as: "div",
      fontFamily: "system",
      size: "Caption1",
      className: styles.container
    }, label, /*#__PURE__*/React.createElement("div", getArrowProps({
      className: styles.arrow
    }))))), only ? /*#__PURE__*/React.cloneElement(only, {
      ref: setTriggerRef,
      'aria-describedby': id
    }, only.props.children) : /*#__PURE__*/React.createElement("span", {
      ref: setTriggerRef,
      "aria-describedby": id
    }, /*#__PURE__*/React.createElement(Icon, {
      color: "grey60",
      as: Info,
      size: "small",
      role: "button",
      tabIndex: "0"
    })));
  };

  Tooltip.displayName = 'Tooltip';
  Tooltip.identifier = Tooltip.displayName; // used in docs website

  Tooltip.clonableProps = SYSTEM_PROPS;
  Tooltip.defaultProps = {
    placement: 'top',
    usePortal: false,
    defaultVisible: false
  };
  return Tooltip;
}();

export default Tooltip;